import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SincePipe } from './since.pipe';

@NgModule({
  declarations: [SincePipe],
  imports: [
    CommonModule
  ],
  exports: [SincePipe]
})
export class SinceModule { }
